export default {
    name: 'flex1',

    render() {
        return <div style="flex: 1" />;
    }
};
